import { motion } from 'framer-motion'
import { ReactNode } from 'react'

export const COLLAPSE_DURATION = 0.5

interface CollapseProps {
  isOpen: boolean
  disableInitialAnimation?: boolean
  children: ReactNode
  className?: string
}

function Collapse({ isOpen, disableInitialAnimation, children, className }: CollapseProps) {
  return (
    <motion.div
      className={className}
      key="hb-collapse-element"
      initial={disableInitialAnimation && isOpen ? 'open' : 'collapsed'}
      animate={isOpen ? 'open' : 'collapsed'}
      exit="collapsed"
      variants={{
        open: { opacity: 1, height: 'auto', overflow: 'initial' },
        collapsed: { opacity: 0, height: 0, overflow: 'hidden' },
      }}
      transition={{ duration: COLLAPSE_DURATION, ease: [0.04, 0.62, 0.23, 0.98] }}
    >
      {children}
    </motion.div>
  )
}

export default Collapse
